<template>
  <div>
    <b-card header="Rekomendasi Pembimbing" sub-title="Tuliskan nama lengkap Pembimbing Akademik dan Pembimbing Skripsi yang akan memberikan rekomendasi bagi Anda">
     
    <validation-observer v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(onSubmit)">
        <b-row>
          <!-- Pembimbing Akademik -->
          <b-col md="6">
            <b-form-group
              label="Nama Lengkap Pembimbing Akademik/Skripsi Tugas Akhir *"
            >
              <validation-provider v-slot="{ errors }" name="Nama Lengkap Pembimbing Akademik" rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }">
                <b-form-input v-model="form.nama_lengkap_pembimbing_akademik" id="nama_lengkap_pembimbing_akademikInput"></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Email Pembimbing Akademik/Skripsi Tugas Akhir*"
            >
              <validation-provider v-slot="{ errors }" name="Email Pembimbing Akademik" rules="required|email">
                <b-form-input v-model="form.email_pembimbing_akademik" id="email_pembimbing_akademikInput" type="email"></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Alert -->
        <b-alert :show="rekomendasiPembimbingAkademik !== null" variant="success" class="mt-1 p-1 d-flex align-items-center" v-if="rekomendasiPembimbingAkademik">
          <feather-icon icon="check" class="mr-1"></feather-icon>
          Rekomendasi sudah tersedia pada tanggal {{ tanggalrekomendasiPembimbingAkademik }}
        </b-alert>
        <b-alert :show="dataDefault.email_pembimbing_akademik === null" variant="warning" class="mt-1 p-1 d-flex align-items-center">
          <b-row>
            <b-col md="12">
              <feather-icon icon="AlertTriangleIcon" class="mr-1 icon-size"></feather-icon>
              Rekomendasi tidak tersedia
            </b-col>
            <b-col md="12">
              <small>{{ messageRekomendasiPembimbingAkademik }}</small>
            </b-col>
          </b-row>
        </b-alert>
        <b-alert :show="dataDefault.email_pembimbing_akademik !== null" variant="success" class="mt-1 p-1 d-flex align-items-center">
              <b-row>
                <b-col md="12">
                  <b-button @click="handleResend(form.uuid, form.email_pembimbing_akademik)" variant="success" class="mt-1"><feather-icon icon="MailIcon" class="ml-1 mr-1"></feather-icon> Kirim Ulang Notifikasi</b-button>
                </b-col>
              </b-row>
          </b-alert>
          <b-row class="hidden">
            <!-- Pembimbing Skripsi -->
            <b-col md="6">
              <b-form-group
                label="Nama Lengkap Pembimbing Skripsi *"
              >
                <!-- <validation-provider v-slot="{ errors }" name="Nama Lengkap Pembimbing Skripsi" rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"> -->
                  <b-form-input v-model="form.nama_pembimbing_skripsi" id="nama_pembimbing_skripsiInput"></b-form-input>
                  <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                <!-- </validation-provider> -->
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Email Pembimbing Skripsi *"
              >
                <!-- <validation-provider v-slot="{ errors }" name="Email Pembimbing Skripsi" rules="required|email"> -->
                  <b-form-input v-model="form.email_pembimbing_skripsi" id="email_pembimbing_skripsiInput" type="email"></b-form-input>
                  <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                <!-- </validation-provider> -->
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Alert -->
          <!-- <b-alert :show="rekomendasiPembimbingSkripsi !== null" variant="success" class="mt-1 p-1 d-flex align-items-center" v-if="rekomendasiPembimbingSkripsi">
            <feather-icon icon="check" class="mr-1"></feather-icon>
            Rekomendasi sudah tersedia pada tanggal {{ tanggalrekomendasiPembimbingSkripsi }}
          </b-alert> -->
          <!-- <b-alert :show="dataDefault.email_pembimbing_skripsi === null" variant="warning" class="d-flex align-items-center hidden">
            <b-row>
              <b-col md="12">
                <feather-icon icon="AlertTriangleIcon" class="mr-1 icon-size"></feather-icon>
                Rekomendasi tidak tersedia
              </b-col>
              <b-col md="12">
                <small>{{ messageRekomendasiPembimbingSkripsi }}</small>
              </b-col>
            </b-row>
          </b-alert> -->
          <!-- <b-alert :show="dataDefault.email_pembimbing_skripsi !== null" variant="success" class="mt-1 p-1 d-flex align-items-center">
              <b-row>
                <b-col md="12">
                  <b-button @click="handleResend(form.uuid, form.email_pembimbing_skripsi)" variant="success" class="mt-1"><feather-icon icon="MailIcon" class="ml-1 mr-1"></feather-icon> Kirim Ulang Notifikasi</b-button>
                </b-col>
              </b-row>
          </b-alert> -->
          <b-row>
            <!-- Atasan -->
            <b-col md="6">
              <b-form-group
                label="Nama lengkap atasan jika pernah/sedang bekerja (opsional bagi yang belum bekerja)"
              >
                <validation-provider v-slot="{ errors }" name="Nama Lengkap Atasan">
                  <b-form-input v-model="form.nama_lengkap_atasan" id="nama_lengkap_atasanInput"></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Email Atasan (Opsional)"
              >
                <validation-provider v-slot="{ errors }" name="Email Atasan">
                  <b-form-input v-model="form.email_atasan" id="email_atasanInput" type="email"></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Alert -->
          <!-- <b-alert :show="rekomendasiAtasan !== null" variant="success" class="mt-1 p-1 d-flex align-items-center" v-if="rekomendasiAtasan">
            <feather-icon icon="check" class="mr-1"></feather-icon>
            Rekomendasi sudah tersedia pada tanggal {{ tanggalRekomendasiAtasan }}
          </b-alert> -->
          <b-alert :show="dataDefault.email_atasan === null" variant="warning" class="mt-1 p-1 d-flex align-items-center">
            <b-row>
              <b-col md="12">
                <feather-icon icon="AlertTriangleIcon" class="mr-1 icon-size"></feather-icon>
                Rekomendasi tidak tersedia
              </b-col>
              <b-col md="12">
                <small>{{ messageRekomendasiAtasan }}</small>
              </b-col>
            </b-row>
          </b-alert>
        

        <!-- Tombol -->
        <b-row class="mt-3">
          <b-col>
            <b-button type="submit" variant="primary" class="mr-1" :disabled="loaderShow == true">Simpan <b-spinner small label="Spinning" v-if="loaderShow == true"></b-spinner></b-button>
            <b-button @click="handleReset" >Cancel</b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import {
  required,
  integer,
  regex,
  confirmed,
  // min,
  // max,
  email
} from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});

import {
  BCard,
  BAlert,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormTextarea,
  BButton,
  BFormDatepicker,
  BMedia, BMediaAside, BMediaBody,
  BFormFile,
  BImg,
  BFormSelect,
  BTable,
  BLink,
  BSpinner,
} from 'bootstrap-vue';
import {
  getRekomendasi,
  updateRekomendasi,
  resendRekomendasi,
} from '@/connection-api/rekomendasi'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BAlert,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormTextarea,
    BButton,
    BFormDatepicker,
    BMedia, BMediaAside, BMediaBody,
    BFormFile,
    BImg,
    BFormSelect,
    BTable,
    BLink,
    BSpinner,
  },
  data() {
    return {
      required,
      integer,
      regex,
      confirmed,
      loaderShow: false,
      // min,
      // max,
      email,
      dataDefault: {
        uuid: '',
        nama_pembimbing_skripsi: '',
        email_pembimbing_skripsi: '',
        nama_lengkap_pembimbing_akademik: '',
        email_pembimbing_akademik: '',
        nama_lengkap_atasan: '',
        email_atasan: '',
      },
      form: {
        uuid: '',
        nama_pembimbing_skripsi: '',
        email_pembimbing_skripsi: '',
        nama_lengkap_pembimbing_akademik: '',
        email_pembimbing_akademik: '',
        nama_lengkap_atasan: '',
        email_atasan: '',
      },
      // ... (variabel lainnya)
      rekomendasiPembimbingSkripsi: "Baiknya adalah melanjutkan",
      tanggalRekomendasiPembimbingSkripsi: '23 November 2023',
      messageRekomendasiPembimbingSkripsi: 'Form Rekomendasi belum diisi.',
      rekomendasiPembimbingAkademik: null,
      tanggalRekomendasiPembimbingAkademik: '',
      messageRekomendasiPembimbingAkademik: 'Form Rekomendasi belum diisi.',
      rekomendasiAtasan: null,
      tanggalRekomendasiAtasan: '',
      messageRekomendasiAtasan: 'Form Rekomendasi belum diisi.',
    };
  },
  mounted() {
    this.getRekomendasi();
  },
  methods: {
    async getRekomendasi(){
      const response = await getRekomendasi();
      if (response.data) {
        this.dataDefault = response.data.data;
        this.form = response.data.data;
      }
    },
    async onSubmit() {
      // Lakukan sesuatu ketika formulir disubmit
      this.loaderShow = true
      const responseUpdate = await updateRekomendasi(this.form)
        .then(response => {
          if (response.data.status.code === '01') {
            // Tampilkan pesan error kepada pengguna, misalnya dengan menggunakan alert atau modal
            this.$bvModal.msgBoxOk(response.data.status.message, {
              title: 'Gagal',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              hideHeaderClose: false
            });
            this.loaderShow = false
          } else {
            this.$bvModal.msgBoxOk('Data Rekomendasi berhasil disimpan, dan mengirimkan email', {
              title: 'Sukses',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              hideHeaderClose: false
            });
            this.loaderShow = false
          }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error, {
              title: 'Gagal',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              hideHeaderClose: false
            });
        });

    },
    async handleResend(uuid, email)
    {
      this.loaderShow = true
      const responseResend = await resendRekomendasi()
        .then(response => {
          if(response.data.status.code === '00'){
            this.$bvModal.msgBoxOk(`Notifikasi sudah dikirimkan ke alamat email ${email}`, {
                  title: 'Sukses',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'success',
                  headerClass: 'p-2 border-bottom-0',
                  footerClass: 'p-2 border-top-0',
                  hideHeaderClose: false
                });
              this.loaderShow = false
          }else{
            this.$bvModal.msgBoxOk(`Mohon maaf pengiriman notifikasi ke alamat email ${email} hanya dapat dilakukan satu kali sehari.`, {
                  title: 'Informasi',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'success',
                  headerClass: 'p-2 border-bottom-0',
                  footerClass: 'p-2 border-top-0',
                  hideHeaderClose: false
                });
              this.loaderShow = false
          }
        }).catch(error => {
          this.$bvModal.msgBoxOk(error, {
              title: 'Gagal',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              hideHeaderClose: false
            });
            this.loaderShow = false
        });
      
    },
    handleReset() {
      // Lakukan reset formulir
    }
  }
};
</script>
<style scoped>
.icon-size {
  width: 32px;
  /* Set your desired width */
  height: 32px;
  /* Set your desired height */
}
</style>